import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface LaundryItemParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface LaundryItem {
    id?: any;
    tenantId: any;
    branchId: any;
    name:string;
    washRate?:number;
    mItemRate?:number;
    
    parameters?: LaundryItemParameter[];
    links?: any;
}


export abstract class LaundryItemData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<LaundryItem[]>;
    abstract create(url: string, data: LaundryItem):
     Observable<LaundryItem[]>;
    abstract update(url: string, data: LaundryItem): Observable<LaundryItem>;
    abstract delete(url: string): Observable<any>;
}
